export const namespaced = true;

export const state = {
    flightsWithCO2Info: [],
}

export const mutations = {
    ADD_CO2_TO_FLIGHTS_INFO(state, payload){
        state.flightsWithCO2Info.push(payload);
    },
}

export const actions = {
    addCO2ToFlightsInfo(context, payload){
        context.commit('ADD_CO2_TO_FLIGHTS_INFO', payload);
    }
}

export const getters = {}